import React from "react";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import { Link } from "react-router-dom";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import { UseFirmList } from "../../hooks/Catalogs/useFirm";
import { defaultPageSize } from "../../utils/const";
import useDataLoader2 from "../../hooks/useDataLoader2";
import Filters, { IFilterData } from "../../components/Catalogs/Filters/Filters";
import { UserAccessOptions } from "../../Enums";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const User: React.FC = () => {
  const { firmData } = UseFirmList();
  const endpoint = "/user";

  const {
    data,
    totalCount,
    fetchData,
    setFilter,
    sort,
    setSort,
    pagination,
    setPagination,
    inputFilters,
    setInputFilters,
    filter,
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    defaultSorting: { field: "fullName", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>
          {rowIndex + 1 + pagination.pageIndex * pagination.pageSize}
        </p>
      ),
      enableSorting: false,
    },
    { id: "fullName", header: "Name" },
    { id: "generatedId", header: "Generated ID" },
    { id: "firmName", header: "Firm" },
    { id: "firmEmail", header: "Email" },
    { id: "access", header: "Access" },
    {
      id: "edit",
      header: "Edit",
      enableSorting: false,
      cell: ({ row, rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <Link
          className="edit"
          to={`Edit/${row.id}`}
          state={data[rowIndex]}
        >
          Edit
          <div className="editsvg">
            <ShapeEdit />
          </div>
        </Link>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, data]);

  const formatData = (data: any) => {
    const formattedData = data.map((subject: any) => {
      return {
        ... subject,
        fullName: subject
          ? [
              subject.honorary,
              subject.name,
              subject.middleInitial,
              subject.lastName,
              subject.suffix,
            ]
              .filter((part) => part)
              .join(" ")
          : "",
      };
    });
    return formattedData;
  };

  const filtersData: IFilterData[] = React.useMemo(() => [
      {
        name: "Name",
        type: "text",
        comparison: "CONTAINS",
      },
      {
        name: "Firm",
        fieldName: "firm",
        objectData: firmData?.map((f: any) => ({id:f.id, name: f.name})) || [],
        comparison: "EQUAL",
      },
      {
        name: "Access", 
        objectData: UserAccessOptions || [],
        comparison: "EQUAL",
        disabledWrite: true,
      },
    ], [firmData, UserAccessOptions]);

  return (
    <>
      <div>
        <CatalogTableC
          title={`User Catalog`}
          catalogName={"USER"}
          route={"User"}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter} 
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            sorting={sort}
            onSortingChange={setSort}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
              })
            }
          />
        </CatalogTableC>
      </div>
    </>
  );
};

export default User;
